module.exports = __webpack_public_path__ + "assets/images/project/constituencies/ang-mo-kio-grc.jpg?v=d84dcb44";